document.addEventListener('DOMContentLoaded', function () {
    let isMobile = window.innerWidth <= 991;
    const dropdownItems = document.querySelectorAll('.navigation__item.dropdown');
	const dropdownSelectors = '.dropdown--navigation.show';


    // Inicializace dropdownů
    dropdownItems.forEach(item => setupDropdown(item));

    // Při změně velikosti okna reinicializace
	window.addEventListener('resize', () => {
		isMobile = window.innerWidth <= 991;
		// Není potřeba odstraňovat posluchače, protože při každém resize se stránka stejně překresluje a posluchače se nepřidávají duplicitně
		dropdownItems.forEach(item => setupDropdown(item));
		closeAllDropdowns();
		adjustNavigationTop();
	});

    // Zavřít dropdown při kliknutí na zpět
    document.querySelectorAll('.js-toggle-nav-dropdown').forEach(button => {
        button.addEventListener('click', closeAllDropdowns);
    });

    // Zavřít dropdown při stisku Escape
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
            closeAllDropdowns();
        }
    });

    // Responsive navigace
    initializeResponsiveNav();

    // Nastavení top pozice navigace
    adjustNavigationTop();
    window.addEventListener('resize', adjustNavigationTop);

    // --- Funkce ---

    function setupDropdown(item) {
        const button = item.querySelector('.js-dropdown-toggle');
        const menu = item.querySelector('.dropdown--navigation');
        if (!button || !menu) return;

        // Nastav aria-expanded podle stavu menu
        button.setAttribute('aria-expanded', menu.classList.contains('show') ? 'true' : 'false');

        // Zabránit zavření při kliknutí uvnitř menu
        menu.addEventListener('click', stopPropagation, false);

        if (isMobile) {
            button.addEventListener('click', onMobileClick, false);
        } else {
            item.addEventListener('mouseenter', onDesktopEnter, false);
            item.addEventListener('mouseleave', onDesktopLeave, false);
            // Na desktopu neblokujeme click - odkaz bude fungovat normálně
        }

        // --- Handlery ---
        function onMobileClick(event) {
            event.preventDefault(); // Zablokuj proklik na mobilu
            event.stopPropagation();
            closeAllDropdowns();
            toggleDropdown(button, menu);
        }

        let hoverTimeout;
        let enterTimeout; // Nový timeout pro zpoždění otevření

        function onDesktopEnter() {
            clearTimeout(hoverTimeout);
            clearTimeout(enterTimeout); // Vyčisti předchozí timeout

            // Přidej zpoždění 300ms před otevřením dropdownu
            enterTimeout = setTimeout(() => {
                // Zavřít všechny ostatní dropdowny před otevřením nového
                closeAllDropdowns();
                openDropdown(button, menu);
            }, 200); // 200ms zpoždění - můžeš upravit podle potřeby
        }

        function onDesktopLeave() {
            clearTimeout(enterTimeout); // Zruš otevření, pokud uživatel rychle opustí položku
            hoverTimeout = setTimeout(() => {
                closeDropdown(button, menu);
            }, 200);
        }
    }

    function stopPropagation(event) {
        event.stopPropagation();
    }
    function stopEvent(event) {
        event.preventDefault();
        event.stopPropagation();
    }

    function toggleDropdown(button, menu) {
        if (button.getAttribute('aria-expanded') === 'true') {
            closeDropdown(button, menu);
        } else {
            openDropdown(button, menu);
        }
    }

    function openDropdown(button, menu) {
        button.setAttribute('aria-expanded', 'true');
        menu.classList.add('show');
        menu.setAttribute('tabindex', '-1');
        //menu.focus();
        document.body.classList.add('body-with-nav');
        ensureBackdropExists();
    }

    function closeDropdown(button, menu) {
        button.setAttribute('aria-expanded', 'false');
        menu.classList.remove('show');
        menu.removeAttribute('tabindex');
		if (!document.querySelector(dropdownSelectors)) {
            document.body.classList.remove('body-with-nav');
            removeBackdrop();
        }
    }

    function closeAllDropdowns() {
        document.querySelectorAll(dropdownSelectors).forEach(menu => {
            const button = menu.parentNode.querySelector('.js-dropdown-toggle') ||
                document.querySelector(`[aria-controls="${menu.id}"]`) ||
                menu.parentNode.querySelector('button');
            if (button) {
                closeDropdown(button, menu); // místo button.click()
            }
        });
    }

    function ensureBackdropExists() {
        let backdrop = document.querySelector('.navigation__backdrop');
        if (!backdrop) {
            backdrop = document.createElement('div');
            backdrop.className = 'navigation__backdrop';
            document.body.appendChild(backdrop);
            requestAnimationFrame(() => {
                backdrop.classList.add('show');
            });
        } else {
            backdrop.classList.add('show');
        }
    }

    function removeBackdrop() {
        const backdrop = document.querySelector('.navigation__backdrop');
        if (backdrop) {
            backdrop.classList.remove('show');
            backdrop.addEventListener('transitionend', () => {
                if (!backdrop.classList.contains('show')) {
                    backdrop.remove();
                }
            }, { once: true });
        }
    }

    function adjustNavigationTop() {
        const isMobileNow = window.innerWidth <= 991;
        const notification = document.querySelector('.notification');
        const header = document.querySelector('.header');
        const navigation = document.querySelector('.navigation');

        if (isMobileNow && navigation && header) {
            let topOffset = header.offsetHeight;
            if (notification) {
                topOffset += notification.offsetHeight;
            }
            navigation.style.top = `${topOffset}px`;
            navigation.style.paddingBottom = `${topOffset}px`;
        } else if (navigation) {
			navigation.style.top = '';
            navigation.style.paddingBottom = `0px`;
        }
    }

    function initializeResponsiveNav() {
        const responsiveToggle = document.querySelector('.navigation__responsive');
        const navigation = document.querySelector('.navigation');
        const searchCol = document.querySelector('.col--search');

        if (responsiveToggle && navigation) {
            responsiveToggle.addEventListener('click', function () {
                responsiveToggle.classList.toggle('responsive--active');
                document.body.classList.toggle('show-nav');

                if (!responsiveToggle.classList.contains('responsive--active')) {
                    document.body.classList.remove('body-with-nav');
                    if (searchCol) {
                        searchCol.classList.remove('show');
                    }
                } else {
                    document.body.classList.add('body-with-nav');
                    if (searchCol) {
                        searchCol.classList.add('show');
                    }
                }
            });
        }
    }
});



// toggler subnavigace delší než 6 položek
document.addEventListener('DOMContentLoaded', function() {
    const toggleButtons = document.querySelectorAll('[data-toggle="subnav-collapse"]');

    toggleButtons.forEach(button => {
        button.addEventListener('click', function() {
            const container = this.closest('.subnav-categories');
            const hiddenItems = container.querySelectorAll('.subnav-categories__item--hidden');
            const isExpanded = this.getAttribute('aria-expanded') === 'true';

            hiddenItems.forEach(item => {
                item.style.display = isExpanded ? 'none' : 'block';
            });

            this.setAttribute('aria-expanded', !isExpanded);
            this.querySelector('.subnav-categories__toggle-text').textContent =
                isExpanded ? 'Další' : 'Méně';
        });
    });
});